import { render, staticRenderFns } from "./fracionamentoKitEmbalagem.vue?vue&type=template&id=5ffb7b39"
import script from "./fracionamentoKitEmbalagem.ts?vue&type=script&lang=js&external"
export * from "./fracionamentoKitEmbalagem.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\TafStore.PharmUP.Client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ffb7b39')) {
      api.createRecord('5ffb7b39', component.options)
    } else {
      api.reload('5ffb7b39', component.options)
    }
    module.hot.accept("./fracionamentoKitEmbalagem.vue?vue&type=template&id=5ffb7b39", function () {
      api.rerender('5ffb7b39', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/parent/crud/produtolote/fracionamentoKitEmbalagem.vue"
export default component.exports